import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useState, useEffect } from "react";

const DateRange = ({
  inputBeginDate,
  setInputBeginDate,
  beginDate,
  setBeginDate,
  setInputEndDate,
  setEndDate,
  inputEndDate,
  endDate
}) => {
  const [localBeginDate, setLocalBeginDate] = useState(inputBeginDate);
  const [localEndDate, setLocalEndDate] = useState(inputEndDate);

  useEffect(() => {
    setLocalBeginDate(inputBeginDate);
    setLocalEndDate(inputEndDate);
  }, [inputBeginDate, inputEndDate]);

  const getCurrentDate = (data) => {
    if (data && "toISOString" in data) {
      return data.toISOString().slice(0, 10);
    }
  };

  const handleChangeBeginDate = (e) => {
    const date = e.value ? e.value : e;
    setLocalBeginDate(date);
  };

  const handleChangeEndDate = (e) => {
    const date = e.value ? e.value : e;
    setLocalEndDate(date);
  };

  const handleApplyDates = () => {
    if (localBeginDate) {
      setInputBeginDate(localBeginDate);
      const currentBeginDate = getCurrentDate(localBeginDate);
      if (currentBeginDate && currentBeginDate.length === 10) {
        setBeginDate(currentBeginDate);
      }
    }
    if (localEndDate) {
      setInputEndDate(localEndDate);
      const currentEndDate = getCurrentDate(localEndDate);
      if (currentEndDate && currentEndDate.length === 10) {
        setEndDate(currentEndDate);
      }
    }
  };

  const handleSetDefaultDates = () => {
    const endDate = new Date(new Date().getFullYear(), 11, 31);
    const beginDate = new Date(new Date().getFullYear(), 0, 1);
    setLocalBeginDate(beginDate);
    setLocalEndDate(endDate);
    setInputBeginDate(beginDate);
    setInputEndDate(endDate);
    // Aplica automaticamente o ano vigente
    const currentBeginDate = getCurrentDate(beginDate);
    const currentEndDate = getCurrentDate(endDate);
    if (currentBeginDate && currentBeginDate.length === 10) {
      setBeginDate(currentBeginDate);
    }
    if (currentEndDate && currentEndDate.length === 10) {
      setEndDate(currentEndDate);
    }
  };

  return (
    <div className="p-field pt-2">
      <h5 className="p-m-0">Período</h5>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className={"chamados-table-header-periodo"}>
          <div>
            <small>Início</small>
            <Calendar
              style={{ width: "100%" }}
              mask="99/99/9999"
              value={localBeginDate}
              onChange={handleChangeBeginDate}
            />
          </div>
          <div>
            <small>Fim</small>
            <Calendar
              style={{ width: "100%" }}
              mask="99/99/9999"
              value={localEndDate}
              onChange={handleChangeEndDate}
            />
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
          <Button
            label={"Aplicar"}
            onClick={handleApplyDates}
            icon="pi pi-check"
            className={"text-white"}
            style={{ fontWeight: "regular" }}
          />
          <Button
            label={"Ano Vigente"}
            onClick={handleSetDefaultDates}
            className={"text-white"}
            style={{ fontWeight: "regular" }}
          />
        </div>
      </div>
    </div>
  );
};

export default DateRange;
